import React, { useEffect, useCallback, useState, useRef } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { FiSearch } from 'react-icons/fi';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { formatPrice } from '../../utils/format';
import Sidebar from '../../components/Sidebar';
import InputDate from '../../components/Inputs/InputDate';
import Loading from '../../components/Loading';
import ModalEntrega from '../../components/Modal/ModalEntrega';
import DataTableEntregas from '../../components/ComponentsEntregas/DataTableEntregas';

import { Container, Content, Filtros, FormView, ListVazio } from './styles';

type DateData = {
  data_i: string;
  data_f: string;
};
type EntregaData = {
  id_entrega: number;
  id_loja: number;
  id_venda: number;
  id_entregador: number;
  nome_entregador: string;
  nome_cliente: string;
  tipo_venda: string;
  data_venda: string;
  data_entrega: string;
  data_previsao: string;
  atraso: string;
  tempo: string;
  obs_entrega: string;
  pago: string;
  evento: string;
  motivo: string;
  vlr_custo: number;
  vlr_entrega: number;
  vlr_troco: number;
  vlr_total: number;
  vlr_custoFormatted: string;
  vlr_entregaFormatted: string;
  vlr_trocoFormatted: string;
  vlr_totalFormatted: string;
};

const Entregas: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const { company } = useAuth();

  const [loading, setLoading] = useState(true);
  const [entregas, setEntregas] = useState<EntregaData[]>([]);
  const [modalEntregaVisible, setModalEntregaVisible] = useState(false);
  const [entregaModal, setEntregaModal] = useState<EntregaData>(
    {} as EntregaData,
  );

  const handleGetEntregas = useCallback(async (data: DateData) => {
    setLoading(true);
    await api
      .post('portal/entrega/index', data)
      .then(response => {
        if (response.data.length > 0) {
          const deliverys = response.data.map((entrega: EntregaData) => {
            return {
              ...entrega,
              vlr_custoFormatted: formatPrice(entrega.vlr_custo),
              vlr_entregaFormatted: formatPrice(entrega.vlr_entrega),
              vlr_trocoFormatted: formatPrice(entrega.vlr_troco),
              vlr_totalFormatted: formatPrice(entrega.vlr_total),
            };
          });

          setEntregas(deliverys);
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    handleGetEntregas({} as DateData);
  }, [handleGetEntregas, company]);

  // UseEffect para bloquear a rolagem ao abrir algum modal
  useEffect(() => {
    if (modalEntregaVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [modalEntregaVisible]);

  return (
    <>
      {modalEntregaVisible && (
        <ModalEntrega
          onClose={() => setModalEntregaVisible(false)}
          isVisible={modalEntregaVisible}
          entrega={entregaModal}
        />
      )}

      <Container>
        {loading && <Loading />}

        <Sidebar />

        <Content>
          <Filtros>
            <FormView ref={formRef} onSubmit={handleGetEntregas}>
							<Flex width="100%">
                <div className="input-content">
                  <span>Data Inicial</span>
                  <InputDate
                    name="data_i"
                    placeholder="Data Inicial"
                    containerStyle={{ padding: '7px ' }}
                  />
                </div>

                <div className="input-content">
                  <span>Data Final</span>
                  <InputDate
                    name="data_f"
                    placeholder="Data Final"
                    containerStyle={{ padding: '7px ' }}
                  />
                </div>
							</Flex>

							<Flex>
								<div className="input-content input-content-button">
                  <span>&nbsp;</span>
                  <button type="submit">
                    <FiSearch /> Pesquisar
                  </button>
                </div>
							</Flex>
            </FormView>
          </Filtros>

          {entregas.length > 0 && (
            <DataTableEntregas
              data={entregas}
              setEntregaModal={setEntregaModal}
              setModalEntregaVisible={setModalEntregaVisible}
            />
          )}

          {entregas.length === 0 && (
            <ListVazio>
              <h3>Nenhum entrega neste período.</h3>
            </ListVazio>
          )}
        </Content>
      </Container>
    </>
  );
};

export default Entregas;
